import React, { useRef } from 'react';
import { FiEdit2 } from 'react-icons/fi';
import { TitleInputContainer, TitleInputStyled } from './style';

const TitleInput = React.forwardRef(({ ...rest }, ref) => {
  const innerRef = useRef();
  const passedRef = ref || innerRef;
  return (
    <TitleInputContainer>
      <TitleInputStyled expandDirection="horizontal" textareaRef={passedRef} {...rest} />
      <button
        type="button"
        onClick={() => {
          if (passedRef.current) {
            passedRef.current.focus();
          }
        }}
      >
        <FiEdit2 />
      </button>
    </TitleInputContainer>
  );
});

export default TitleInput;
